/* eslint-disable */
import { generate, format } from 'build-number-generator';

export const BASE_URL = Config_BaseUrl;
export const API_KEY = Config_ApiKey;
export const WEB_APP_URL = Config_WebAppUrl;
export const BASE_URL_FILE = Config_BaseUrlFile;


export const BUILD_DATE = format(Config_BuildDate);
export const BUILD_NUMBER = generate({ version: '1.0' });


export const DocumentContextId_Property = 3;
export const NoteContextId_PropertyFeedback = 36;
export const BuyerStatus_Cancelled = 99;

export const SysSettingId_PropertyWebUrl = 3;
export const SysSettingId_DefaultCountryId = 6;
